export default {
    DOCUMENTEN_CONTROL: {
        VALIDATION: {
            INVALID_EXTENSION: "Het bestand '{{filename}}' bezit een verboden extensie, enkel zijn {{extensions}} toegestaan.",
            VALIDATIONS_ALL_DOCUMENTEN: 'Gelieve een documenttype te selecteren voor alle documenten.',
            TOO_LARGE_SIZE: "Het bestand '{{filename}}' is groter dan {{size}}.",
            MULTIPLE_FALSE: 'Het is niet toegelaten om meerdere documenten op te laden.'
        },
        UPLOAD_SUCCESS: 'Het bestand werd succesvol opgeladen.',
        UPLOAD_PROGRESS: '{{value}}% opgeladen.',
        UPLOAD_ERROR: 'Er heeft zich een fout voorgedaan bij het opladen van het bestand.',
        CONFIRM_DELETE: 'Bent u zeker dat u dit document wilt verwijderen?',
        CONFIRM_ONTKOPPELING: 'Bent u zeker dat u dit document wilt verwijderen uit het dossier?',
        CONFIRM_ONTKOPPELING_VERSIE: 'Bent je zeker dat je het document enkel wilt ontkoppelen van dossierversie nr.',
        NIET_BEWAARD: 'Niet bewaard',
        ADD_DOCUMENTEN: 'Documenten toevoegen',
        ADD_DOCUMENT: 'Document toevoegen',
        UPDATE_DOCUMENT: 'Document wijzigen',
        ADD_DOCUMENTEN_EXTERN: 'Bijlage toevoegen',
        ADD_DOCUMENT_EXTERN: 'Bijlage toevoegen',
        UPDATE_DOCUMENT_EXTERN: 'Bijlage wijzigen',
        DROP_ZONE: 'Selecteer bestanden of sleep ze hier naar toe',
        MODUS_LIST: 'Tegelweergave',
        MODUS_GRID: 'Lijstweergave',
        EXTERN_ZICHTBAAR: 'Extern zichtbaar',
        NIET_EXTERN_ZICHTBAAR: 'Extern niet zichtbaar',
        DOCUMENTEN_CENTRUM: 'Openen in documentencentrum',
        DOWNLOAD: 'Document downloaden',
        EMAIL_METADATA: 'E-mail metadata',
        TOEPASSEN_OP_ALLE: 'Onderstaande eigenschappen toepassen op alle documenten',
        DOCUMENT_FINAAL: 'De inhoud van het document is finaal',
        KUNNEN_BEWERKEN: ' Ik wil de inhoud nog kunnen bewerken',
        KOPPELEN_DOSSIERS_TAKEN: 'Koppelen met dossiers en taken',
        KOPPELEN_HUIDIG: 'Koppelen aan het huidig dossier',
        STANDAARD_KOPPELING_DOSSIERS: 'Standaard koppeling voor dossiers aanmaken',
        STANDAARD_KOPPELING_TAKEN: 'Standaard koppeling voor taken aanmaken',
        BACK: 'Terug',
        GALERIJ_BEKIJKEN: 'Bekijken in galerij',
        BIJLAGEN_INDIVIDUEEL_OPSLAGEN: 'Bijlagen individueel opslaan',
        BERICHT_TONEN_ELOKET: "Als 'Mijn bericht' op het e-loket tonen",
        BERICHT_TONEN_ELOKET_NIET_ZICHTBAAR: 'Deze optie is niet mogelijk omdat het gekozen documenttype niet zichtbaar is op het e-loket.',
        BERICHT_TONEN_ELOKET_GEEN_EMAIL: 'Deze optie is niet mogelijk omdat het bestand geen e-mail is',
        BERICHT_TONEN_ELOKET_NIET_VERZONDEN: 'Deze optie is niet mogelijk omdat concept e-mails niet op het e-loket mogen verschijnen',
        GEEN_PREVIEW_VERSNIPPERD: 'Het is niet mogelijk om een versnipperd document te bekijken.'
    },
    COMMON: {
        ACTION: {
            EDIT: 'Wijzigen',
            DELETE: 'Verwijder het document uit dit dossier.',
            DELETE_NOT_ALLOWED: 'Extern opgeladen document kan niet verwijderd worden',
            DELETE_NOT_ALLOWED_INTERN: 'Het document is nog niet ingediend door de klant en mag dus nog niet beheerd worden.',
            DELETE_NOT_ALLOWED_GEENRECHTEN: 'U hebt niet voldoende rechten om dit document te verwijderen',
            OK: 'Bewaren',
            CANCEL: 'Annuleren',
            CLOSE: 'Sluiten',
            SIDE_NAVIGATION: 'Navigatiemenu'
        }
    },
    FIELD: {
        DOCUMENTNUMMER: 'Documentnummer',
        DOCUMENTTYPE: 'Documenttype',
        DOCUMENTTYPE_NAAM: 'Documenttype naam',
        DOCUMENTTYPE_CODE: 'Documenttype code',
        DOCUMENTTYPE_OMSCHRIJVING: 'Documenttype omschrijving',
        OORSPRONG: 'Oorsprong',

        ONDERWERP: 'Onderwerp',
        BESTANDSNAAM: 'Bestandsnaam',
        TYPE: 'Type',
        ZICHTBAARHEID: 'Zichtbaarheid',
        AANGEMAAKT_DATUM: 'Aangemaakt op',
        KLANTEN: 'Klantnummer',
        KLANTNAAM: 'Klantnaam',
        DOSSIERS: 'Dossiers',
        DOSSIERVERSIES: 'Dossier Versies',
        AANGEMAAKTDOOR: 'Aangemaakt door',
        STATUS: 'Documentstatus',

        GEWIJZIGD_DOOR: 'Gewijzigd door',
        GEWIJZIGD_DATUM: 'Gewijzigd op',

        DOCUMENTSTATUS: 'Documentstatus',
        TAKEN: 'Taken'
    },
    VALIDATION: {
        REQUIRED: "Het veld '{{field}}' is verplicht."
    }
} as const;
